$(document).ready(function() {
  $('.section-activity .tabs .tab').on('click', function(event) {
    const index = $(this).data('index');
    const isCurrent =  $(this).hasClass('active')
    if (!isCurrent) {
      $('.section-activity .tabs .tab').removeClass('active');
      $(this).addClass('active');
      $(`.section-activity .product`).hide();
      $(`.section-activity .product[data-index="${index}"]`).show()
    }
  })
});